<template>
  <div class="app-main-inner">
    <div class="app-main-top">
      <div class="app-goback" @click="goback">
        <b></b>{{ $t("lang.classRoom1") }}
      </div>
      <div class="app-main-title">{{ this.title }}</div>
    </div>
    <div class="app-main-middle">
      <div class="courseware-pdf" v-show="!isDynamic">
        <div class="courseware-pdf-status" v-if="!loaded">
          loading...
        </div>
        <div v-if="pageUrlBase" class="courseware-img">
          <img v-lazy="`${pageUrlBase + page + imgFormat}`" />
        </div>
        <div class="no-data" v-else>
          {{ $t("lang.classRoom5") }}
        </div>
        <div
          class="button-prev button-navigation"
          @click="prevPdf($event)"
          v-if="loaded"
        >
          {{ $t("lang.classRoom2") }}
        </div>
        <div
          class="button-next button-navigation"
          @click="nextPdf($event)"
          v-if="loaded"
        >
          {{ $t("lang.classRoom3") }}
        </div>
        <div class="page-forward">
          <span class="fl">{{ $t("lang.classRoom4") }}：</span>
          <div class="page-box">
            <input
              type="text"
              v-model.number="page"
              @keyup="pageResize($event)"
              maxlength="3"
            />
            <div class="totlePage" v-if="numPages">/ {{ numPages }}</div>
          </div>
        </div>
      </div>
      <div class="dynamic-ppt" v-if="isDynamic">
        <iframe
          v-if="documentId"
          :src="iframeURL"
          ref="iframe"
          width="100%"
          height="560"
          frameborder="0"
          scrolling="auto"
        />
      </div>
      <div class="note-box" v-if="loaded">
        <label for="note">{{ $t("lang.classRoom6") }} {{ page }}</label>
        <textarea
          name="note"
          id="note"
          :placeholder="$t('lang.classRoom6')"
          v-if="numPages > 1"
          v-model="pageArr[pageIndex].note"
          maxlength="500"
        ></textarea>
        <textarea
          name="note"
          id="note"
          :placeholder="$t('lang.classRoom6')"
          v-else
          v-model="pageArr[pageIndex].note"
          maxlength="500"
        ></textarea>
        <div class="btn" @click="_editSlideNote(true)">
          {{ $t("lang.loginPage15") }}
        </div>
        <div v-if="pageArr[pageIndex].systemNote">
          <label for="note">{{ $t("lang.classRoom38") }} {{ page }}</label>
          <textarea
            name="note"
            id="note"
            :placeholder="$t('lang.classRoom38')"
            v-if="numPages > 1"
            :disabled="true"
            v-model="pageArr[pageIndex].systemNote"
            maxlength="500"
          ></textarea>
          <textarea
            name="note"
            id="note"
            :placeholder="$t('lang.classRoom6')"
            v-else
            :disabled="true"
            v-model="pageArr[0].systemNote"
            maxlength="500"
          ></textarea>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSlideNote, editSlideNote, getDocPages } from "api/course";
import { ERR_OK } from "api/config";
import pdf from "vue-pdf";
export default {
  data() {
    return {
      title: decodeURIComponent(this.$route.query.title),
      SlideNoteParma: {
        lessonId: this.$route.query.lessonId
          ? Number.parseInt(this.$route.query.lessonId)
          : ""
      },
      docIdParma: {
        roomId: this.$route.query.roomId
        ? this.$route.query.roomId
        : ''
      },
      lessonModel: this.$route.query.lessonModel ? this.$route.query.lessonModel : '',
      pageArr: [],
      tmpPageArr: [],
      SlideNoteArr: [],
      pageUrlBase: "",
      imgFormat: "",
      page: 1,
      numPages: 1,
      loaded: false,
      iframeURL: null,
      documentId: null,
      iframeData: null
    };
  },
  created() {
    this._getDocPages();
    this.getDocumentId();
    if (this.lessonModel === 'DYNAMIC_PPT') {
      window.addEventListener('message', this.handleMessage, false);
    }
  },
  computed: {
    pageIndex: function() {
      return parseInt(this.page - 1);
    },
    isDynamic () {
      return this.lessonModel === 'DYNAMIC_PPT'
    }
  },
  components: {
    pdf
  },
  methods: {
    _getSlideNote() {
      getSlideNote(this.SlideNoteParma)
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              this.SlideNoteArr = response.data.data.sildeNotes;
              let SlideNoteArr = response.data.data.sildeNotes;
              for (var i = 0; i < this.numPages; i++) {
                this.pageArr[i] = {
                  note: ""
                };
                this.tmpPageArr[i] = {
                  note: ""
                };
              }
              for (let x in SlideNoteArr) {
                let pageIndex = SlideNoteArr[x].pageIndex;
                this.pageArr[pageIndex - 1] = SlideNoteArr[x];
              }
              this.loaded = true;
            } else {
              this.loaded = false;
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.loaded = false;
          this.$message.error(e.message);
        });
    },
    _getDocPages() {
      getDocPages(this.SlideNoteParma)
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === +ERR_OK) {
              this.pageUrlBase = response.data.data.pageUrlBase;
              this.imgFormat = response.data.data.imgFormat;
              this.numPages = +response.data.data.totalPageSize;
              this._getSlideNote();
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    },
    _editSlideNote(msgFlag) {
      if (
        this.pageArr[this.page - 1].note === this.tmpPageArr[this.page - 1].note
      ) {
        return false;
      }
      let noteParma = Object.assign({}, this.SlideNoteParma, {
        note: this.pageArr[this.page - 1].note,
        pageIndex: this.page
      });
      editSlideNote(noteParma)
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              if (msgFlag === true) {
                this.$message.success(this.$t("lang.classRoom9"));
              }
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          // this.$message.error(e.message);
        });
    },
    goback() {
      this.$router.go(-1);
    },
    pageResize(event) {
      let value = parseInt(event.target.value);
      console.log(value);
      if (value === " ") {
      } else if (value <= 0) {
        this.page = 1;
      } else if (value > this.numPages) {
        this.page = this.numPages;
      }
    },
    prevPdf(event) {
      if (this.page > 1) {
        this._editSlideNote(false);
        this.page--;
      }
    },
    nextPdf(event) {
      if (this.page < this.numPages) {
        this._editSlideNote(false);
        this.page++;
      }
    },
    getDocumentId() {
      const docId = this.$route.query.documentId ? this.$route.query.documentId : '';
      this.documentId = docId;
      this.iframeURL = `${process.env.BASE_DOC_URL}/#/classroom/preview/1v1/${docId}/0`;
    },
    handleMessage(e) {
      const data = JSON.parse(e.data)
      this.page = data.data.currentPage + 1
      console.log(data)
      this._editSlideNote(false);
    }
  },
  watch: {
    page (val) {
      console.log(val)
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~styles/variables.scss";
@import "~styles/mixin.scss";
.courseware-pdf {
  width: 600px;
  border-radius: 6px;
  position: relative;
  margin: 0 auto 50px;
  background: #f5f5f5;
  .courseware-img {
    position: relative;
    img {
      display: block;
      width: 100%;
    }
  }
  .courseware-pdf-status {
    position: absolute;
    width: 100%;
    height: 450px;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 20px;
    color: #ffa438;
    background: #fff;
  }
  .swiper-container {
    height: 100%;
  }
  .button-navigation {
    width: 108px;
    height: 26px;
    line-height: 26px;
    background: rgba(255, 164, 56, 0.5);
    color: #333;
    font-size: 12px;
    text-align: center;
    border: 1px solid $baseColor;
    position: absolute;
    bottom: -43px;
    right: 0;
    border-radius: 20px;
    z-index: 9;
    cursor: pointer;
  }
  .button-next {
    right: 0px;
  }
  .button-prev {
    right: 120px;
  }
  .button-disabled {
    background: #dedede;
    border: 1px solid #dedede;
  }
  .page-forward {
    height: 26px;
    line-height: 24px;
    text-align: center;
    position: absolute;
    bottom: -43px;
    .page-box {
      display: inline-block;
      float: left;
      width: 48px;
      height: 24px;
      border: 1px solid #dedede;
      border-radius: 4px;
      outline: 0;
      padding: 0px 10px;
      text-align: center;
      position: relative;
      z-index: 9;
      input {
        display: block;
        width: 28px;
        height: 24px;
        line-height: 24px;
        padding: 0;
        border: 0;
        outline: none;
        text-indent: 5px;
        font-size: 12px;
        color: $baseColor;
      }
      .totlePage {
        position: absolute;
        height: 24px;
        line-height: 24px;
        right: 15px;
        top: 0px;
        color: #999;
        font-size: 12px;
      }
    }
    .page-forward-btn {
      display: inline-block;
      width: 48px;
      height: 24px;
      line-height: 24px;
      background: rgba(255, 164, 56, 0.5);
      color: #333;
      border: 1px solid $baseColor;
      text-align: center;
      border-radius: 20px;
      margin-left: 10px;
      cursor: pointer;
      font-size: 12px;
    }
  }
}
.note-box {
  width: 600px;
  margin: 100px auto 20px;
  textarea {
    width: 558px;
    display: block;
    border: 0;
    border-radius: 4px;
    padding: 20px;
    outline: none;
    color: #333;
    resize: none;
    height: 140px;
    border: 1px solid #dedede;
    margin: 20px 0px 40px;
    &::-webkit-input-placeholder {
      color: #ccc;
    }
  }
  .btn {
    width: 200px;
    height: 36px;
    line-height: 30px;
    margin: 0 auto;
  }
}

.dynamic-ppt {
  padding: 0 90px;
}
</style>



// WEBPACK FOOTER //
// src/views/classroom/lesson-info.vue